__turbopack_context__.v({
  "related-post-grid": "RelatedPosts-module-scss-module__1-vDtq__related-post-grid",
  "related-posts": "RelatedPosts-module-scss-module__1-vDtq__related-posts",
  "title": "RelatedPosts-module-scss-module__1-vDtq__title",
});
